import React, { useState } from "react";
import Plan from "../components/auth/Plan";
import OnboardingBox from "../components/OnboardingBox";
import Button from "../components/sub-component/Button";
import { useMediaQuery } from "@mui/material";
import { refreshToken } from "../redux/thunks/Auth";
import { removeAllClientData } from "../utils/utilities";
import { useDispatch, useSelector } from "react-redux";
import { createSubscription } from "../redux/thunks/Subscription";
import { ReactComponent as ArrowRightAlt } from "../assets/icons/pricing/arrow-right.svg";

export default function PlanPage() {
  const isOnTabletScreen = useMediaQuery(
    "(min-width:768px) and (max-width:1279px)",
  );
  const isOnMobileScreen = useMediaQuery("(max-width: 767px)");
  const [showFeatureComparison, setShowFeatureComparison] = useState(false);

  const dispatch = useDispatch();
  const auth = useSelector((state) => state.authReducer);
  const subscription = useSelector((state) => state.subscriptionReducer);

  const handleConfirmPlan = async (plan) => {
    await dispatch(
      createSubscription({
        stripe_product_id: plan?.id,
        interval: plan?.interval,
      }),
    );
    await dispatch(refreshToken());
  };

  if (auth.data.role.name === "Admin" || auth.data.role.name === "Member") {
    return (
      <>
        <OnboardingBox>
          <div className="d-flex flex-column signup-form-container">
            <div className="form">
              <div
                className={`heading ${isOnMobileScreen || isOnTabletScreen ? "hero-small" : "headline-medium"} bold`}
              >
                Onboarding Pending
              </div>
              <div
                className={`body-${isOnMobileScreen || isOnTabletScreen ? "1" : "3"} light`}
                style={{ marginTop: "10px" }}
              >
                Please reach out to the owner of this account to complete the
                onboarding for this organization.
              </div>
              <div className="submit-button" style={{ marginTop: "32px" }}>
                <Button
                  rectangle-button
                  title={"Sign out"}
                  style={{ height: "48px" }}
                  onClick={() => {
                    removeAllClientData();
                  }}
                />
              </div>
            </div>
          </div>
        </OnboardingBox>
      </>
    );
  }

  return (
    <div
      style={{ backgroundColor: "#F6F5F8", minHeight: "100vh", width: "100%" }}
    >
      <OnboardingBox enableFullPage={true} varrient={"primary"}>
        <div
          className="w-100"
          style={{
            // maxWidth: '1200px',
            margin: "0 auto",
            padding: isOnMobileScreen ? "16px" : "20px 40px",
          }}
        >
          <div
            style={{
              backgroundColor: "white",
              borderRadius: "24px",
            }}
          >
            <Plan
              onConfirmPlan={handleConfirmPlan}
              tenant_status={auth.data.tenant_status}
              processing={subscription?.is_loading}
              showFeatureComparison={showFeatureComparison}
              setShowFeatureComparison={setShowFeatureComparison}
            />
          </div>

          <div
            className="mt-4"
            style={{
              backgroundColor: "white",
              padding: "16px",
              borderRadius: "24px",
            }}
          >
            <div className="mb-2 d-flex">
              <button
                type="button"
                onClick={() => setShowFeatureComparison(true)}
                style={{
                  color: "#7C21FF",
                  background: "none",
                  border: "none",
                  padding: 0,
                  cursor: "pointer",
                  display: "flex",
                }}
                className="d-flex align-items-center body-1"
              >
                Compare all features
                <ArrowRightAlt
                  style={{
                    width: "24px",
                    height: "24px",
                    marginLeft: "8px",
                  }}
                />
              </button>
            </div>
            <div className="d-flex">
              <span className="d-flex body-1 dark-50">
                See a side-by-side comparison of all plan limits and features.
              </span>
            </div>
          </div>
        </div>
      </OnboardingBox>
    </div>
  );
}
